// import * as actionTypes from "../../actions/campaigns/actionTypes";
import * as actionTypes from "../../actions/support/actionTypes";
import { updateObject } from "../../utility/utility";

const initialState = {
  error: false,
  errors: null,
  requestCreated: {},
  allSupportRequests: [],
  isSpinning: false,
  loadingRequests: false,
};

const createRequestSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    requestCreated: action.response,
    isSpinning: false,
  });
};

const createRequestFail = (state, action) => {
  return updateObject(state, {
    error: true,
    errors: action.error,
    isSpinning: false,
  });
};

const getSupportRequestsSuccess = (state, action) => {
  return updateObject(state, {
    error: false,
    isSpinning: false,
    loadingRequests: false,
    allSupportRequests: action.response,
  });
};

const getSupportRequestsFail = (state, action) => {
  return updateObject(state, {
    error: true,
    errors: action.error,
    isSpinning: false,
    loadingRequests: false,
  });
};

const supportRequestStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loadingRequests: action?.pageLimit === 1 ? true : false,
    isSpinning: action?.pageLimit === 1 ? false : true,
  });
};
const supportRequestLoading = (state, action) => {
  return updateObject(state, {
    isSpinning: true,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_SUPPORT_REQUEST_SUCCESS:
      return createRequestSuccess(state, action);
    case actionTypes.CREATE_SUPPORT_REQUEST_FAIL:
      return createRequestFail(state, action);
    case actionTypes.GET_SUPPOR_REQUESTS_SUCCESS:
      return getSupportRequestsSuccess(state, action);
    case actionTypes.GET_SUPPORT_REQUESTS_FAIL:
      return getSupportRequestsFail(state, action);
    case actionTypes.SUPPORT_REQUEST_START:
      return supportRequestStart(state, action);
    case actionTypes.SUPPORT_REQUEST_LOADING:
      return supportRequestLoading(state, action);
    default:
      return state;
  }
};

export default reducer;
